export const exportResponseAdapter = (response) => {
  return response?.response || {};
};
